import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
export const PANEL_ITEM_PADDING_CSS = css `
  padding: 5px;
`;
const BASE_CSS = css(PANEL_ITEM_PADDING_CSS, css `
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  `);
export const PanelItem = ({ children, onClick, selected, color, backgroundColor, hoverColor, ariaLabel, selectedColor = '#ffffff', justifyContent = true, flexWrap = false, allowUserSelect = true, // TODO: Default this to false and test all instances.
typographyVariant, dataTestId }) => {
    const containerCss = [BASE_CSS];
    if (backgroundColor) {
        containerCss.push(css `
      background-color: ${backgroundColor};
    `);
    }
    if (color) {
        containerCss.push(css `
      color: ${color};
    `);
    }
    if (justifyContent) {
        containerCss.push(css `
      justify-content: space-between;
    `);
    }
    if (flexWrap) {
        containerCss.push(css `
      flex-wrap: wrap;
    `);
    }
    if (onClick) {
        containerCss.push(css `
      cursor: pointer;
    `);
    }
    if (selected) {
        containerCss.push(css `
      background-color: ${selectedColor};
    `);
    }
    else if (hoverColor) {
        containerCss.push(css `
      &:hover {
        background-color: ${hoverColor};
      }
    `);
    }
    if (!allowUserSelect) {
        containerCss.push(css `
      user-select: none;
    `);
    }
    return (_jsx("div", { "aria-label": ariaLabel, "data-testid": dataTestId, children: _jsx(Typography, { css: containerCss, component: 'div', onClick: onClick, variant: typographyVariant, children: children }) }));
};
